<template>
      <infoPaciente class="px-2 pt-2" :tipo="1"></infoPaciente>
</template>

<script>

import infoPaciente from '../../paciente/pacienteInfoOs'

export default {

  components: {
    infoPaciente
  }

}
</script>
